// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__WbAjx","pagination__wrapper":"Pagination_pagination__wrapper__J+UBq"};